import { filterDiffFunction, getArrayEditIndex } from './chunk-X6IVGVL4.mjs';
import { areSettingsMasterModeSelector, timeZoneToText, getTimeFromUTCCore } from './chunk-RO5AAHK3.mjs';
import { i18n_config_default } from './chunk-5FPUWZMY.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/settingsDifferences/diffGeneralSettingsFactory.ts
var InformationFieldLabels = /* @__PURE__ */ ((InformationFieldLabels2) => {
  InformationFieldLabels2[InformationFieldLabels2["name"] = 0] = "name";
  InformationFieldLabels2[InformationFieldLabels2["websiteUrl"] = 1] = "websiteUrl";
  InformationFieldLabels2[InformationFieldLabels2["phoneNumber"] = 2] = "phoneNumber";
  InformationFieldLabels2[InformationFieldLabels2["digitalLogoUrl"] = 3] = "digitalLogoUrl";
  InformationFieldLabels2[InformationFieldLabels2["printLogoUrl"] = 4] = "printLogoUrl";
  InformationFieldLabels2[InformationFieldLabels2["streetLine1"] = 5] = "streetLine1";
  InformationFieldLabels2[InformationFieldLabels2["streetLine2"] = 6] = "streetLine2";
  InformationFieldLabels2[InformationFieldLabels2["city"] = 7] = "city";
  InformationFieldLabels2[InformationFieldLabels2["state"] = 8] = "state";
  InformationFieldLabels2[InformationFieldLabels2["postalCode"] = 9] = "postalCode";
  return InformationFieldLabels2;
})(InformationFieldLabels || {});
var GeneralFieldLabels = /* @__PURE__ */ ((GeneralFieldLabels2) => {
  GeneralFieldLabels2[GeneralFieldLabels2["clockInMode"] = 0] = "clockInMode";
  GeneralFieldLabels2[GeneralFieldLabels2["pinpadLayout"] = 1] = "pinpadLayout";
  GeneralFieldLabels2[GeneralFieldLabels2["allowUserToBeLoggedIntoMultipleTablets"] = 2] = "allowUserToBeLoggedIntoMultipleTablets";
  return GeneralFieldLabels2;
})(GeneralFieldLabels || {});
var HoursOfOperationChangesFieldLabels = /* @__PURE__ */ ((HoursOfOperationChangesFieldLabels2) => {
  HoursOfOperationChangesFieldLabels2[HoursOfOperationChangesFieldLabels2["timeZone"] = 0] = "timeZone";
  HoursOfOperationChangesFieldLabels2[HoursOfOperationChangesFieldLabels2["endOfBusinessDay"] = 1] = "endOfBusinessDay";
  return HoursOfOperationChangesFieldLabels2;
})(HoursOfOperationChangesFieldLabels || {});
var HoursOfOperationFields = /* @__PURE__ */ ((HoursOfOperationFields2) => {
  HoursOfOperationFields2[HoursOfOperationFields2["day"] = 0] = "day";
  HoursOfOperationFields2[HoursOfOperationFields2["startTime"] = 1] = "startTime";
  HoursOfOperationFields2[HoursOfOperationFields2["endTime"] = 2] = "endTime";
  return HoursOfOperationFields2;
})(HoursOfOperationFields || {});
var HOURS_OF_OPERATION_FIELD = "operationalDayHours";
var returnLabel = (field) => {
  if (field in InformationFieldLabels) {
    return i18n_config_default.t(
      `app.modals.generalSettingsDiffModal.information.${field}`
    );
  }
  if (field in GeneralFieldLabels) {
    return i18n_config_default.t(
      `app.modals.generalSettingsDiffModal.general.${field}`
    );
  }
  if (field in HoursOfOperationChangesFieldLabels) {
    return i18n_config_default.t(
      `app.modals.generalSettingsDiffModal.hoursOfOperation.changes.${field}`
    );
  }
  if (field in HoursOfOperationFields) {
    return i18n_config_default.t(
      `app.modals.generalSettingsDiffModal.hoursOfOperation.hoursOfOperation.${field}`
    );
  }
};
var getArraysByAction = (diffArray) => {
  const changedHoursOfOperationDiff = diffArray.filter(
    (diff) => diff.path.length === 4 && diff.path[0] === HOURS_OF_OPERATION_FIELD && diff.kind === "E"
  );
  const removedOrAddedHoursOfOperationDiff = diffArray.filter(
    (diff) => diff.path.length === 2 && diff.path[0] === HOURS_OF_OPERATION_FIELD && diff.kind === "A"
  );
  return {
    changedHoursOfOperationDiff,
    removedOrAddedHoursOfOperationDiff
  };
};
var timeToDiff = (time, index) => {
  const timeDiff = {
    id: time.id,
    index,
    tabletGeneratedId: time.id,
    action: "add",
    label: "",
    changes: []
  };
  Object.entries(time).forEach(([timeKey, timeValue]) => {
    const diff = {
      field: timeKey,
      label: returnLabel(timeKey) || "",
      value: timeValue
    };
    if (timeKey in HoursOfOperationFields) {
      timeDiff.changes.push(diff);
    }
  });
  return timeDiff;
};
var diffGeneralSettingsFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const information = generateInformationObj(diffArray, state);
    const general = generateGeneralObj(diffArray);
    const hoursOfOperation = generateHoursOfOperationObj(diffArray, state);
    return {
      information,
      general,
      hoursOfOperation
    };
  }
  return null;
};
var generateInformationObj = (diffArray, state) => {
  const isMasterMode = areSettingsMasterModeSelector(state);
  const informationRootField = isMasterMode ? "organization" : "location";
  const information = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (!(field in InformationFieldLabels)) {
          return;
        }
        switch (field) {
          case "name":
            return information.push(__spreadProps(__spreadValues({}, newDiff), {
              label: i18n_config_default.t(
                `app.modals.generalSettingsDiffModal.information.${informationRootField}Name`
              )
            }));
          case "phoneNumber":
            return information.push(__spreadProps(__spreadValues({}, newDiff), {
              label: i18n_config_default.t(
                `app.modals.generalSettingsDiffModal.information.${informationRootField}PhoneNumber`
              )
            }));
          case "websiteUrl":
            return information.push(__spreadProps(__spreadValues({}, newDiff), {
              label: i18n_config_default.t(
                `app.modals.generalSettingsDiffModal.information.${informationRootField}WebsiteUrl`
              )
            }));
        }
        information.push(newDiff);
      },
      returnLabel
    )
  );
  return information;
};
var generateGeneralObj = (diffArray) => {
  const general = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (!(field in GeneralFieldLabels)) {
          return;
        }
        if (field === "clockInMode") {
          return general.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: i18n_config_default.t(
              `settingsModule.generalSettings.generalSettings.clockInMode.values.${newDiff.value}`
            )
          }));
        }
        if (field === "pinpadLayout") {
          return general.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: i18n_config_default.t(
              `settingsModule.generalSettings.generalSettings.pinpadLayout.values.${newDiff.value}`
            )
          }));
        }
        if (field === "allowUserToBeLoggedIntoMultipleTablets") {
          return general.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: newDiff.value ? i18n_config_default.t("commonTexts.yes") : i18n_config_default.t("commonTexts.no")
          }));
        }
        general.push(newDiff);
      },
      returnLabel
    )
  );
  return general;
};
var generateHoursOfOperationObj = (diffArray, state) => {
  const originalData = state.settings.changeData.originalData;
  const changes = [];
  const hoursOfOperation = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  };
  const { changedHoursOfOperationDiff, removedOrAddedHoursOfOperationDiff } = getArraysByAction(diffArray);
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength, newDiff }) => {
        if (diffLength !== 1) {
          return;
        }
        if (!(field in HoursOfOperationChangesFieldLabels)) {
          return;
        }
        if (field === "timeZone") {
          return changes.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: timeZoneToText(newDiff.value)
          }));
        } else if (field === "endOfBusinessDay") {
          return changes.push(__spreadProps(__spreadValues({}, newDiff), {
            textValue: getTimeFromUTCCore(
              newDiff.value,
              state,
              false,
              false
            )
          }));
        }
        changes.push(newDiff);
      },
      returnLabel
    )
  );
  changedHoursOfOperationDiff.forEach((diff) => {
    filterDiffFunction(
      diff,
      ({ newDiff }) => {
        var _a, _b, _c;
        if (!(newDiff.field in HoursOfOperationFields)) {
          return;
        }
        const day = diff.path[1];
        const index = Number(diff.path[2]);
        const timeId = (_c = (_b = (_a = originalData.operationalDayHours) == null ? void 0 : _a[day]) == null ? void 0 : _b[index]) == null ? void 0 : _c.id;
        const newTimeDiff = {
          label: day,
          action: "update",
          id: timeId,
          tabletGeneratedId: timeId,
          changes: [newDiff],
          index
        };
        const hoursOfOperationIndex = getArrayEditIndex(
          timeId,
          hoursOfOperation[day]
        );
        const hasHoursOfOperationIndex = hoursOfOperationIndex >= 0;
        if (hasHoursOfOperationIndex) {
          hoursOfOperation[day][hoursOfOperationIndex].changes.push(newDiff);
        } else {
          hoursOfOperation[day].push(newTimeDiff);
        }
      },
      returnLabel
    );
  });
  removedOrAddedHoursOfOperationDiff.forEach((diff) => {
    var _a, _b, _c, _d;
    const wasRemoved = ((_a = diff.item) == null ? void 0 : _a.kind) === "D";
    const day = diff.path[1];
    const index = Number(diff.index);
    const id = wasRemoved ? ((_b = diff.item) == null ? void 0 : _b.lhs).id : ((_c = diff.item) == null ? void 0 : _c.rhs).id;
    const newTimeDiff = {
      label: day,
      index,
      action: wasRemoved ? "remove" : "add",
      tabletGeneratedId: id,
      id,
      changes: wasRemoved ? [] : timeToDiff((_d = diff.item) == null ? void 0 : _d.rhs, index).changes
    };
    hoursOfOperation[day].push(newTimeDiff);
  });
  return {
    changes,
    hoursOfOperation
  };
};

export { diffGeneralSettingsFactory };
